import React,{Component,useState } from 'react';
import {Collapse,Container,Navbar,NavbarBrand,NavbarToggler,NavItem,NavLink,Dropdown,DropdownToggle,DropdownMenu,DropdownItem} from 'reactstrap';
import {Link, useLocation} from 'react-router-dom';
import '../console.scss'

export function NavMenuLeft(props) {
  var location = useLocation();
  return <NavMenuLeftInner {...props} pathname={location.pathname} />;
}

class NavMenuLeftInner extends Component {

  constructor(props) {
    super(props);
    this.state = {
      collapsed: true,
      showSecond: 0,
      ToolsToggle:false,
      MasterToggle:false,
      CustomerToggle:false,
      pendingCount: 0,
      contactUnread: 0
    };
  }
componentDidMount(){
  var groups = this.getGroupMatches(this.props.pathname || window.location.pathname);
  this.setState({ ToolsToggle: groups.tools, CustomerToggle: groups.customer, MasterToggle: groups.master });
  this.loadPending();
  this._pendingTimer = setInterval(() => this.loadPending(), 60000);
}

getGroupMatches(path) {
  path = path || '';
  var tools = /^\/console\/(programplus|tools\/|grouprequest)/.test(path);
  var customer = /^\/console\/customer/.test(path);
  var master = /^\/console\/master\//.test(path);
  return { tools, customer, master };
}
componentWillUnmount(){
  if (this._pendingTimer) clearInterval(this._pendingTimer);
}
loadPending(){
  fetch('api/grouprequest?status=pending')
    .then(r => r.ok ? r.json() : [])
    .then(list => this.setState({ pendingCount: list.length }))
    .catch(() => {});
  fetch('api/contact/count')
    .then(r => r.ok ? r.json() : { count: 0 })
    .then(d => this.setState({ contactUnread: d.count || 0 }))
    .catch(() => {});
}
  setDropdownOpen(t){
    var dropdowns = ['ToolsToggle', 'MasterToggle', 'CustomerToggle'];
    var nextOpen = !this.state[t];
    var next = {};
    dropdowns.forEach(k => { next[k] = false; });
    if (nextOpen) next[t] = true;
    this.setState(next);
  }

  render() {

  const {ToolsToggle, MasterToggle, CustomerToggle, pendingCount, contactUnread}= this.state;
  var role = (typeof localStorage !== 'undefined' && localStorage.getItem('role')) || '';
  var isAdmin = role === 'admin';
  var groups = this.getGroupMatches(this.props.pathname || '');
  var toolsActive = ToolsToggle || groups.tools;
  var customerActive = CustomerToggle || groups.customer;
  var masterActive = MasterToggle || groups.master;
  var activeStyle = { background: '#fff5f5', color: '#c82333', borderLeft: '3px solid #dc3545' };
  var wrap = (active) => active ? { display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%', ...activeStyle } : { display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%' };
  var path = this.props.pathname || '';
  var isExact = (p) => path === p;
  var linkStyle = (active, extra) => active ? { ...(extra||{}), ...activeStyle } : (extra || {});
  var closeAllDropdowns = () => this.setState({ ToolsToggle: false, CustomerToggle: false, MasterToggle: false });

    return (
      <Navbar id="navbar-main" className={"navbar-expand-md navbar-toggleable-md ng-white mb-3 "} >
        <Container>
          <Collapse className="d-sm-inline-flex flex-sm-row-reverse " isOpen={!this.state.collapsed} navbar>
            <ul className="nav flex-grow" >
              <NavItem>
                <NavLink tag={Link} className="NavItemLeftLink" to="/console" onClick={closeAllDropdowns}
                  style={linkStyle(isExact('/console') || isExact('/console/'))}>
                  <i className="fas fa-tachometer-alt nav-icon"></i>
                  <span>Console home</span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink tag={Link} className="NavItemLeftLink" to="/console/contact" onClick={closeAllDropdowns}
                  style={linkStyle(isExact('/console/contact'), { display:'flex', alignItems:'center', justifyContent:'space-between' })}>
                  <span><i className="fas fa-envelope-open-text nav-icon"></i>ข้อความติดต่อ</span>
                  {contactUnread > 0 && (
                    <span style={{ background:'#dc3545', color:'#fff', padding:'2px 10px', borderRadius:12, fontSize:11, fontWeight:700, minWidth:24, textAlign:'center' }}>
                      {contactUnread}
                    </span>
                  )}
                </NavLink>
              </NavItem>
              <Dropdown nav isOpen={ToolsToggle}  toggle={()=>true}>
                <DropdownToggle className="NavItemLeftLink" onClick={()=>this.setDropdownOpen("ToolsToggle")} nav style={wrap(toolsActive)}>
                  <span><i className="fas fa-tools nav-icon"></i>Tools</span>
                  <i className={'fas fa-chevron-' + (ToolsToggle ? 'up' : 'down')} style={{ fontSize:11, color:'#888', marginLeft:8 }}></i>
                </DropdownToggle>
                <DropdownMenu className="NavDropdownMenu">
                <DropdownItem tag={Link} className="NavSubItemLeftLink" to="/console/programplus">
                  <i className="fas fa-globe-asia nav-subicon"></i>
                  <span>Program Plus</span>
                </DropdownItem>
                <DropdownItem tag={Link} className="NavSubItemLeftLink" to="/console/tools/homeslide">
                  <i className="fas fa-images nav-subicon"></i>
                  <span>Slide หน้า Home</span>
                </DropdownItem>
                <DropdownItem tag={Link} className="NavSubItemLeftLink" to="/console/tools/hashtag">
                  <i className="fas fa-hashtag nav-subicon"></i>
                  <span>Hashtag หน้าบ้าน</span>
                </DropdownItem>
                <DropdownItem tag={Link} className="NavSubItemLeftLink" to="/console/tools/moment">
                  <i className="fas fa-camera nav-subicon"></i>
                  <span>ภาพประทับใจ</span>
                </DropdownItem>
                <DropdownItem tag={Link} className="NavSubItemLeftLink" to="/console/grouprequest" style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:8 }}>
                  <span><i className="fas fa-users nav-subicon"></i>คำขอจัดกรุ๊ปส่วนตัว</span>
                  {pendingCount > 0 && (
                    <span style={{ background:'#dc3545', color:'#fff', padding:'2px 10px', borderRadius:12, fontSize:11, fontWeight:700, minWidth:24, textAlign:'center' }}>
                      {pendingCount}
                    </span>
                  )}
                </DropdownItem>
                </DropdownMenu>
              </Dropdown>
              <Dropdown nav isOpen={CustomerToggle} toggle={()=>true}>
                <DropdownToggle className="NavItemLeftLink" onClick={()=>this.setDropdownOpen("CustomerToggle")} nav style={wrap(customerActive)}>
                  <span><i className="fas fa-user-friends nav-icon"></i>จัดการลูกค้า</span>
                  <i className={'fas fa-chevron-' + (CustomerToggle ? 'up' : 'down')} style={{ fontSize:11, color:'#888', marginLeft:8 }}></i>
                </DropdownToggle>
                <DropdownMenu className="NavDropdownMenu">
                  <DropdownItem tag={Link} className="NavSubItemLeftLink" to="/console/customer/add">
                    <i className="fas fa-user-plus nav-subicon"></i>
                    <span>เพิ่มลูกค้า</span>
                  </DropdownItem>
                  <DropdownItem tag={Link} className="NavSubItemLeftLink" to="/console/customer">
                    <i className="fas fa-list nav-subicon"></i>
                    <span>รายการลูกค้า</span>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
              <Dropdown nav isOpen={MasterToggle} toggle={()=>true}>
                <DropdownToggle className="NavItemLeftLink" onClick={()=>this.setDropdownOpen("MasterToggle")} nav style={wrap(masterActive)}>
                  <span><i className="fas fa-layer-group nav-icon"></i>Master</span>
                  <i className={'fas fa-chevron-' + (MasterToggle ? 'up' : 'down')} style={{ fontSize:11, color:'#888', marginLeft:8 }}></i>
                </DropdownToggle>
                <DropdownMenu className="NavDropdownMenu">
                <DropdownItem tag={Link} className="NavSubItemLeftLink" to="/console/master/highlights">
                  <i className="fas fa-star nav-subicon"></i>
                  <span>ทำไมต้องไปกับเรา?</span>
                </DropdownItem>
                <DropdownItem tag={Link} className="NavSubItemLeftLink" to="/console/master/icons">
                  <i className="fas fa-icons nav-subicon"></i>
                  <span>Icon ของวัน</span>
                </DropdownItem>
                <DropdownItem tag={Link} className="NavSubItemLeftLink" to="/console/master/location">
                  <i className="fas fa-map-marked-alt nav-subicon"></i>
                  <span>ทวีป / ประเทศ / จังหวัด</span>
                </DropdownItem>
                <DropdownItem tag={Link} className="NavSubItemLeftLink" to="/console/master/airlines">
                  <i className="fas fa-plane nav-subicon"></i>
                  <span>สายการบิน</span>
                </DropdownItem>
                <DropdownItem tag={Link} className="NavSubItemLeftLink" to="/console/master/contactinfo">
                  <i className="fas fa-address-card nav-subicon"></i>
                  <span>ข้อมูลติดต่อ / Social</span>
                </DropdownItem>
                <DropdownItem tag={Link} className="NavSubItemLeftLink" to="/console/master/aboutus">
                  <i className="fas fa-info-circle nav-subicon"></i>
                  <span>เกี่ยวกับเรา</span>
                </DropdownItem>
                </DropdownMenu>
              </Dropdown>
              {isAdmin && (
                <>
                  <NavItem>
                    <NavLink tag={Link} className="NavItemLeftLink" to="/console/users" onClick={closeAllDropdowns}
                      style={linkStyle(isExact('/console/users'))}>
                      <i className="fas fa-users-cog nav-icon"></i>
                      <span>จัดการ User</span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink tag={Link} className="NavItemLeftLink" to="/console/programlog" onClick={closeAllDropdowns}
                      style={linkStyle(isExact('/console/programlog'))}>
                      <i className="fas fa-history nav-icon"></i>
                      <span>ประวัติการแก้ไข</span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink tag={Link} className="NavItemLeftLink" to="/console/auditlog" onClick={closeAllDropdowns}
                      style={linkStyle(isExact('/console/auditlog'))}>
                      <i className="fas fa-user-shield nav-icon"></i>
                      <span>Login / การใช้งาน</span>
                    </NavLink>
                  </NavItem>
                </>
              )}
              <NavItem className="ml-auto">
                <NavLink className="NavItemLeftLink" href="#" onClick={(e) => { e.preventDefault(); localStorage.clear(); window.location.href = '/login'; }}>
                  <i className="fas fa-sign-out-alt nav-icon"></i>
                  <span>ออกจากระบบ</span>
                </NavLink>
              </NavItem>
            </ul>
          </Collapse>
        </Container>
      </Navbar>
    );
  }
}
